/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum LocationPreference {
    WhenUsingCompass = 'when_using_compass',
    EmergencyOnly = 'emergency_only'
}


export function instanceOfLocationPreference(value: any): boolean {
    for (const key in LocationPreference) {
        if (Object.prototype.hasOwnProperty.call(LocationPreference, key)) {
            if (LocationPreference[key as keyof typeof LocationPreference] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LocationPreferenceFromJSON(json: any): LocationPreference {
    return LocationPreferenceFromJSONTyped(json, false);
}

export function LocationPreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationPreference {
    return json as LocationPreference;
}

export function LocationPreferenceToJSON(value?: LocationPreference | null): any {
    return value as any;
}

export function LocationPreferenceToJSONTyped(value: any, ignoreDiscriminator: boolean): LocationPreference {
    return value as LocationPreference;
}

